__turbopack_context__.v({
  "center": "spinner-module-scss-module__k5LAfG__center",
  "large": "spinner-module-scss-module__k5LAfG__large",
  "loading": "spinner-module-scss-module__k5LAfG__loading",
  "medium": "spinner-module-scss-module__k5LAfG__medium",
  "rotation": "spinner-module-scss-module__k5LAfG__rotation",
  "small": "spinner-module-scss-module__k5LAfG__small",
  "tiny": "spinner-module-scss-module__k5LAfG__tiny",
  "wrapper": "spinner-module-scss-module__k5LAfG__wrapper",
});
